// Utility to send audit logs to backend
import api from '../services/api';

export const sendAuditLog = async ({ action, details, userId }) => {
    try {
        await api.post('/api/audit-logs', {
            action,
            details,
            userId,
            timestamp: new Date().toISOString(),
        });
    } catch (err) {
        // Optionally log error to console, but do not block UI
        // console.error('Failed to send audit log', err);
    }
};
